import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { TicketRedemptionModule } from './ticket-redemption/ticket-redemption.module';
import { InfraModule } from './infra/infra.module';
import { JcErrorComponent } from './jc-error/jc-error.component';
import { WaitForJavaComponent } from './wait-for-java/wait-for-java.component';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
/*
const firebaseConfig = {
    apiKey: "AIzaSyChLh0rmXOuPnFMGrfK5z7DGWfJlUF4cHo",
    authDomain: "fs-test-firebase.firebaseapp.com",
    projectId: "fs-test-firebase",
    storageBucket: "fs-test-firebase.appspot.com",
    messagingSenderId: "327999381820",
    appId: "1:327999381820:web:8237672fdac40dee5ebe39",
    measurementId: "G-PFK56ZCRCB"
};
*/
// Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

@NgModule({
    declarations: [
        AppComponent,
        JcErrorComponent,
        WaitForJavaComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LayoutModule,
        MatToolbarModule,
        MatButtonModule,
        MatSidenavModule,
        MatPaginatorModule,
        MatIconModule,
        MatListModule,
        MatGridListModule,
        MatCardModule,
        MatMenuModule,
        TicketRedemptionModule,
        InfraModule,
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }
